/**
 * Maps the installment table returned by GET payments/methods into the
 * { value, label, interest } shape the credit card / Muvicard installment
 * selects already expect.
 * @param {Array} installments [{ count, interestRate, installmentAmount, totalAmount }]
 * @param {number} orderValue The order's total value (used to compute interest)
 * @param {object} options
 * @param {boolean} options.showAVista Show "à vista" for the first (1x) option
 */
export function mapApiInstallments(installments = [], orderValue = 0, { showAVista = false } = {}) {
	return installments.map((item, index) => {
		const installmentValue = item.installmentAmount.$toReais()
		const hasInterest = item.interestRate > 0
		const interest = item.totalAmount - orderValue

		const label =
			showAVista && index === 0
				? `${installmentValue} à vista`
				: `${item.count}x de
						${installmentValue} ${
							hasInterest ? '(Juros: ' + interest.$toReais() + ')' : ' sem juros'
					  }
						 `

		return {
			value: item.count,
			label,
			interest,
		}
	})
}
